import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthConnectComponent } from './oauth-connect.component';
import { LoaderModule, TranslateModule } from '@xref/ngx';

@NgModule({
    declarations: [OauthConnectComponent],
    imports: [
        CommonModule,
        LoaderModule,
        TranslateModule
    ],
    exports: [OauthConnectComponent],
    providers: [],
})
export class OauthConnectModule {}
